/**
 * Where a stock phone camera lands when it scans the pairing QR.
 *
 * The QR has to encode *something*, and a plain URL is the only payload a generic camera app
 * will offer to open. So this page exists to catch the case where the user scanned with the
 * camera instead of inside Magpie -- without it they get the enrolment screen and a prompt for
 * the bootstrap token, which is precisely the thing pairing was built to avoid.
 *
 * It reads the code from the fragment, never the query string: a fragment is not sent to the
 * server, so the code cannot appear in an access log. Nothing here calls the API -- claiming is
 * the app's job, and a browser doing it would burn the single-use code on the wrong device.
 */
export default function PairLanding() {
  const code = new URLSearchParams(location.hash.replace(/^#/, "")).get("code") ?? "";
  const grouped = code.replace(/(.{4})(?=.)/g, "$1-");

  return (
    <div className="enrol stack">
      <div>
        <div className="eyebrow">Listing Trawler</div>
        <h1 style={{ fontSize: 26, marginTop: 6 }}>Pairing code</h1>
        <p className="muted" style={{ fontSize: 14 }}>
          {code
            ? "Scanned with the camera rather than inside Magpie. Open the Magpie app, choose Pair with server, and enter this code."
            : "This link carries no pairing code. Generate a fresh one from System → Pair a phone in the web UI."}
        </p>
      </div>

      {code && (
        <div className="card stack" style={{ gap: 10 }}>
          <div>
            <div className="eyebrow">Code</div>
            <div className="mono" style={{ fontSize: 24, letterSpacing: 1 }}>
              {grouped}
            </div>
          </div>
          <div>
            <div className="eyebrow">Server</div>
            <div className="mono" style={{ fontSize: 13 }}>
              {location.origin}
            </div>
          </div>
          <div className="muted" style={{ fontSize: 13 }}>
            It expires a few minutes after it was generated and works exactly once. If it has
            already lapsed, generate another from the web UI.
          </div>
        </div>
      )}
    </div>
  );
}
